module.exports = __webpack_public_path__ + "img/register-transparent.4915ddae.svg";